const jsonToQueryString = (json) => {
  try {
    if (!json || Object.keys(json).length === 0) {
      return '';
    }
    const query = Object.keys(json)
      .filter((key) => json[key] || json[key] === 0)
      .map(
        (key) => `${encodeURIComponent(key)}=${encodeURIComponent(json[key])}`,
      )
      .join('&');
    return query ? `?${query}` : '';
  } catch {
    return '';
  }
};

export { jsonToQueryString };

